module.exports = __webpack_public_path__ + "static/img/4.6b815659.png";